export enum EAreaMapType {
    PlanDeZone = 1,
    PlanDeSituation = 2,
    PlanDeLingette = 3,
    PlanMassif = 4
}